import { apiJsonHeaders, withApiLocale } from "../utils/apiLocale";

const BASE_URL = "/api/dependents";

// Familiares/perfiles gestionados de un titular (guardian).
export const fetchDependents = async (guardianId) => {
  const res = await fetch(`${BASE_URL}/${guardianId}`, {
    method: "GET",
    headers: apiJsonHeaders(),
  });

  if (!res.ok) {
    const error = await res.json().catch(() => ({}));
    throw new Error(error?.error || "Error al obtener los familiares");
  }

  return res.json();
};

export const createDependent = async (guardianId, fields) => {
  const res = await fetch(BASE_URL, {
    method: "POST",
    headers: apiJsonHeaders(),
    body: JSON.stringify(withApiLocale({ ...fields, guardian_id: guardianId })),
  });

  if (!res.ok) {
    const error = await res.json().catch(() => ({}));
    throw new Error(error?.error || "Error al crear el familiar");
  }

  return res.json();
};

export const updateDependent = async (id, guardianId, fields) => {
  const res = await fetch(`${BASE_URL}/${id}`, {
    method: "PUT",
    headers: apiJsonHeaders(),
    body: JSON.stringify(withApiLocale({ ...fields, guardian_id: guardianId })),
  });

  if (!res.ok) {
    const error = await res.json().catch(() => ({}));
    throw new Error(error?.error || "Error al actualizar el familiar");
  }

  return res.json();
};

export const deleteDependent = async (id, guardianId) => {
  const res = await fetch(
    `${BASE_URL}/${id}?guardian_id=${encodeURIComponent(guardianId)}`,
    {
      method: "DELETE",
      headers: apiJsonHeaders(),
    }
  );

  if (!res.ok) {
    const error = await res.json().catch(() => ({}));
    throw new Error(error?.error || "Error al eliminar el familiar");
  }

  return res.json();
};
